/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './hack-result-modal.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../components/hack-results-viewer/hack-results-viewer.module.ngfactory';
import * as i3 from '../../../../../../../../src/app/components/client/shared/components/hack-results-viewer/hack-results-viewer.module';
import * as i4 from '../../../../../../../../src/app/components/client/shared/services/shared-export.service';
import * as i5 from '@angular/common';
import * as i6 from '../../../../../../../../src/app/components/client/shared/modals/hack-result/hack-result-modal.component';
import * as i7 from 'angular2-modal';
import * as i8 from '../../../../../../../../src/app/providers/auth.service';
import * as i9 from '../../../../../../../../src/app/components/client/shared/services/shared-candidate.service';
import * as i10 from '../../../../../../../../src/app/components/client/shared/services/shared-hack.service';
const styles_HackResultModalComponent:any[] = [i0.styles];
export const RenderType_HackResultModalComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_HackResultModalComponent,data:{}});
function View_HackResultModalComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'hack-results-viewer',
      ([] as any[]),[[2,'pdf-mode',(null as any)]],[[(null as any),'onCloseModal']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('onCloseModal' === en)) {
          const pd_0:any = ((<any>_co.closeModal()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_HackResultsViewerComponent_0,i2.RenderType_HackResultsViewerComponent)),
      i1.ɵdid(4308992,(null as any),0,i3.HackResultsViewerComponent,[i4.SharedExportService],
          {hackResults:[0,'hackResults'],hackReports:[1,'hackReports'],candidate:[2,
              'candidate'],uiEventsReport:[3,'uiEventsReport'],credentials:[4,'credentials']},
          {onCloseModal:'onCloseModal'})],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = _co.hackResults;
    const currVal_2:any = _co.hackReports;
    const currVal_3:any = _co.candidate;
    const currVal_4:any = _co.uiEventsReport;
    const currVal_5:any = _co.credentials;
    _ck(_v,1,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).pdfModeClass;
    _ck(_v,0,0,currVal_0);
  });
}
export function View_HackResultModalComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),7,'div',[['class','tag-results-modal-wrapper pad-10']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
      ['\n	'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'div',[['class','row']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['\n		'])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
      1,(null as any),View_HackResultModalComponent_1)),i1.ɵdid(16384,(null as any),
      0,i5.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n	'])),(_l()(),i1.ɵted((null as any),['\n'])),
      (_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i6.HackResultModalComponent = _v.component;
    const currVal_0:any = _co.hackResults;
    _ck(_v,6,0,currVal_0);
  },(null as any));
}
export function View_HackResultModalComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'hack-result-modal',
      ([] as any[]),(null as any),(null as any),(null as any),View_HackResultModalComponent_0,
      RenderType_HackResultModalComponent)),i1.ɵdid(114688,(null as any),0,i6.HackResultModalComponent,
      [i7.DialogRef,i8.AuthService,i9.SharedClientCandidateService,i10.SharedHackService],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const HackResultModalComponentNgFactory:i1.ComponentFactory<i6.HackResultModalComponent> = i1.ɵccf('hack-result-modal',
    i6.HackResultModalComponent,View_HackResultModalComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2NsaWVudC9zaGFyZWQvbW9kYWxzL2hhY2stcmVzdWx0L2hhY2stcmVzdWx0LW1vZGFsLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL25vZGUvYXBwL3NyYy9hcHAvY29tcG9uZW50cy9jbGllbnQvc2hhcmVkL21vZGFscy9oYWNrLXJlc3VsdC9oYWNrLXJlc3VsdC1tb2RhbC5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL25vZGUvYXBwL3NyYy9hcHAvY29tcG9uZW50cy9jbGllbnQvc2hhcmVkL21vZGFscy9oYWNrLXJlc3VsdC9oYWNrLXJlc3VsdC1tb2RhbC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2NsaWVudC9zaGFyZWQvbW9kYWxzL2hhY2stcmVzdWx0L2hhY2stcmVzdWx0LW1vZGFsLmNvbXBvbmVudC50cy5IYWNrUmVzdWx0TW9kYWxDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCJcbjxkaXYgY2xhc3M9XCJ0YWctcmVzdWx0cy1tb2RhbC13cmFwcGVyIHBhZC0xMFwiPlxuXHQ8ZGl2IGNsYXNzPVwicm93XCI+XG5cdFx0PGhhY2stcmVzdWx0cy12aWV3ZXIgKm5nSWY9XCJoYWNrUmVzdWx0c1wiXG5cdFx0XHQgW2hhY2tSZXN1bHRzXT1cImhhY2tSZXN1bHRzXCJcblx0XHRcdCBbaGFja1JlcG9ydHNdPVwiaGFja1JlcG9ydHNcIlxuXHRcdFx0IFt1aUV2ZW50c1JlcG9ydF09XCJ1aUV2ZW50c1JlcG9ydFwiXG5cdFx0XHQgW2NhbmRpZGF0ZV09XCJjYW5kaWRhdGVcIlxuXHRcdFx0IFtjcmVkZW50aWFsc109XCJjcmVkZW50aWFsc1wiXG5cdFx0XHQgKG9uQ2xvc2VNb2RhbCk9XCJjbG9zZU1vZGFsKClcIlxuXHRcdD48L2hhY2stcmVzdWx0cy12aWV3ZXI+XG5cdDwvZGl2PlxuPC9kaXY+XG4iLCI8aGFjay1yZXN1bHQtbW9kYWw+PC9oYWNrLXJlc3VsdC1tb2RhbD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNHRTtNQUFBO01BQUE7UUFBQTtRQUFBO1FBTUU7VUFBQTtVQUFBO1FBQUE7UUFORjtNQUFBO2FBQUE7VUFBQTtjQUFBO1VBQUE7O0lBQ0U7SUFDQTtJQUVBO0lBREE7SUFFQTtJQUxGLFdBQ0UsVUFDQSxVQUVBLFVBREEsVUFFQSxTQUxGOztJQUFBO0lBQUEsV0FBQSxTQUFBOzs7O29CQUhGLHVDQUNBO01BQUE7TUFBQSwwREFBOEM7TUFBQSxVQUM3QztNQUFBLHdFQUFpQjthQUFBLDBCQUNoQjtNQUFBLHlEQUFBO01BQUE7TUFPdUIsd0NBQ2xCO01BQ0Q7O0lBVGlCO0lBQXJCLFdBQXFCLFNBQXJCOzs7O29CQ0hGO01BQUE7eUNBQUEsVUFBQTtNQUFBO01BQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./compiled/src/app/components/client/shared/modals/hack-result/hack-result-modal.component.ngfactory.ts